// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VJ6Q","colBig":"styles_colBig__2hwnE","colSmall":"styles_colSmall__19Znl"};